'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.execHook = execHook;
exports.registerHook = registerHook;
exports.getHooks = getHooks;

var _type = require('../utils/type');

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } // beforeEffect
// afterEffect
// enhanceModule

var hookStore = {
  enhanceStart: [],
  enhanceReducer: [],
  onEffect: [],
  onEffectError: [],
  beforeFetch: [],
  afterFetch: [],
  beforeRegisterModule: [],
  afterRegisterModule: []
};

var applyArguments = function applyArguments(args) {
  return function (func) {
    return func.apply(undefined, _toConsumableArray(args));
  };
};

// 执行某个名字的hook
function execHook(name) {
  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  var hooks = hookStore[name]; // 获取当前 hook 名字对应的一系列待执行函数

  if (_type.is.arr(hooks)) {
    // 如果是数组
    if (/^enhance/.test(name)) {
      // 增强型 hook
      return hooks.reduce(function (ret, next) {
        if (ret == null) return next.apply(undefined, args);
        return next(ret);
      }, null);
    }

    // 非增强型 hook，args 此时必须是一个函数，且会来执行传递进来的每一个 hook
    return hooks.forEach(applyArguments(args));
  }
}

// 注册某个名字的 hook
function registerHook(name, hook) {
  return _type.is.func(hook) && hookStore[name] && hookStore[name].push(hook);
}

function getHooks(name) {
  return hookStore[name] || [];
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL21vZHVsZXMvY29yZS9ob29rcy5qcyJdLCJuYW1lcyI6WyJleGVjSG9vayIsInJlZ2lzdGVySG9vayIsImdldEhvb2tzIiwiaG9va1N0b3JlIiwiZW5oYW5jZVN0YXJ0IiwiZW5oYW5jZVJlZHVjZXIiLCJvbkVmZmVjdCIsIm9uRWZmZWN0RXJyb3IiLCJiZWZvcmVGZXRjaCIsImFmdGVyRmV0Y2giLCJiZWZvcmVSZWdpc3Rlck1vZHVsZSIsImFmdGVyUmVnaXN0ZXJNb2R1bGUiLCJhcHBseUFyZ3VtZW50cyIsImZ1bmMiLCJhcmdzIiwibmFtZSIsImhvb2tzIiwiaXMiLCJhcnIiLCJ0ZXN0IiwicmVkdWNlIiwicmV0IiwibmV4dCIsImZvckVhY2giLCJob29rIiwicHVzaCJdLCJtYXBwaW5ncyI6Ijs7Ozs7UUFvQmdCQSxRLEdBQUFBLFE7UUFpQkFDLFksR0FBQUEsWTtRQUlBQyxRLEdBQUFBLFE7O0FBckNoQjs7b01BSkE7QUFDQTtBQUNBOztBQUlBLElBQU1DLFlBQVk7QUFDaEJDLGdCQUFjLEVBREU7QUFFaEJDLGtCQUFnQixFQUZBO0FBR2hCQyxZQUFVLEVBSE07QUFJaEJDLGlCQUFlLEVBSkM7QUFLaEJDLGVBQWEsRUFMRztBQU1oQkMsY0FBWSxFQU5JO0FBT2hCQyx3QkFBc0IsRUFQTjtBQVFoQkMsdUJBQXFCO0FBUkwsQ0FBbEI7O0FBV0EsSUFBTUMsaUJBQWlCLFNBQWpCQSxjQUFpQjtBQUFBLFNBQVE7QUFBQSxXQUFRQyx5Q0FBUUMsSUFBUixFQUFSO0FBQUEsR0FBUjtBQUFBLENBQXZCOztBQUVBO0FBQ08sU0FBU2QsUUFBVCxDQUFtQmUsSUFBbkIsRUFBa0M7QUFBQSxvQ0FBTkQsSUFBTTtBQUFOQSxRQUFNO0FBQUE7O0FBQ3ZDLE1BQU1FLFFBQVFiLFVBQVVZLElBQVYsQ0FBZCxDQUR1QyxDQUNUOztBQUU5QixNQUFJRSxTQUFHQyxHQUFILENBQU9GLEtBQVAsQ0FBSixFQUFtQjtBQUFFO0FBQ25CLFFBQUksV0FBV0csSUFBWCxDQUFnQkosSUFBaEIsQ0FBSixFQUEyQjtBQUFFO0FBQzNCLGFBQU9DLE1BQU1JLE1BQU4sQ0FBYSxVQUFDQyxHQUFELEVBQU1DLElBQU4sRUFBZTtBQUNqQyxZQUFJRCxPQUFPLElBQVgsRUFBaUIsT0FBT0Msc0JBQVFSLElBQVIsQ0FBUDtBQUNqQixlQUFPUSxLQUFLRCxHQUFMLENBQVA7QUFDRCxPQUhNLEVBR0osSUFISSxDQUFQO0FBSUQ7O0FBRUQ7QUFDQSxXQUFPTCxNQUFNTyxPQUFOLENBQWNYLGVBQWVFLElBQWYsQ0FBZCxDQUFQO0FBQ0Q7QUFDRjs7QUFFRDtBQUNPLFNBQVNiLFlBQVQsQ0FBdUJjLElBQXZCLEVBQTZCUyxJQUE3QixFQUFtQztBQUN4QyxTQUFPUCxTQUFHSixJQUFILENBQVFXLElBQVIsS0FBaUJyQixVQUFVWSxJQUFWLENBQWpCLElBQW9DWixVQUFVWSxJQUFWLEVBQWdCVSxJQUFoQixDQUFxQkQsSUFBckIsQ0FBM0M7QUFDRDs7QUFFTSxTQUFTdEIsUUFBVCxDQUFtQmEsSUFBbkIsRUFBeUI7QUFDOUIsU0FBT1osVUFBVVksSUFBVixLQUFtQixFQUExQjtBQUNEIiwiZmlsZSI6Imhvb2tzLmpzIiwic291cmNlc0NvbnRlbnQiOlsiLy8gYmVmb3JlRWZmZWN0XG4vLyBhZnRlckVmZmVjdFxuLy8gZW5oYW5jZU1vZHVsZVxuXG5pbXBvcnQgeyBpcyB9IGZyb20gJy4uL3V0aWxzL3R5cGUnXG5cbmNvbnN0IGhvb2tTdG9yZSA9IHtcbiAgZW5oYW5jZVN0YXJ0OiBbXSxcbiAgZW5oYW5jZVJlZHVjZXI6IFtdLFxuICBvbkVmZmVjdDogW10sXG4gIG9uRWZmZWN0RXJyb3I6IFtdLFxuICBiZWZvcmVGZXRjaDogW10sXG4gIGFmdGVyRmV0Y2g6IFtdLFxuICBiZWZvcmVSZWdpc3Rlck1vZHVsZTogW10sXG4gIGFmdGVyUmVnaXN0ZXJNb2R1bGU6IFtdXG59XG5cbmNvbnN0IGFwcGx5QXJndW1lbnRzID0gYXJncyA9PiBmdW5jID0+IGZ1bmMoLi4uYXJncylcblxuLy8g5omn6KGM5p+Q5Liq5ZCN5a2X55qEaG9va1xuZXhwb3J0IGZ1bmN0aW9uIGV4ZWNIb29rIChuYW1lLCAuLi5hcmdzKSB7XG4gIGNvbnN0IGhvb2tzID0gaG9va1N0b3JlW25hbWVdIC8vIOiOt+WPluW9k+WJjSBob29rIOWQjeWtl+WvueW6lOeahOS4gOezu+WIl+W+heaJp+ihjOWHveaVsFxuXG4gIGlmIChpcy5hcnIoaG9va3MpKSB7IC8vIOWmguaenOaYr+aVsOe7hFxuICAgIGlmICgvXmVuaGFuY2UvLnRlc3QobmFtZSkpIHsgLy8g5aKe5by65Z6LIGhvb2tcbiAgICAgIHJldHVybiBob29rcy5yZWR1Y2UoKHJldCwgbmV4dCkgPT4ge1xuICAgICAgICBpZiAocmV0ID09IG51bGwpIHJldHVybiBuZXh0KC4uLmFyZ3MpXG4gICAgICAgIHJldHVybiBuZXh0KHJldClcbiAgICAgIH0sIG51bGwpXG4gICAgfVxuXG4gICAgLy8g6Z2e5aKe5by65Z6LIGhvb2vvvIxhcmdzIOatpOaXtuW/hemhu+aYr+S4gOS4quWHveaVsO+8jOS4lOS8muadpeaJp+ihjOS8oOmAkui/m+adpeeahOavj+S4gOS4qiBob29rXG4gICAgcmV0dXJuIGhvb2tzLmZvckVhY2goYXBwbHlBcmd1bWVudHMoYXJncykpXG4gIH1cbn1cblxuLy8g5rOo5YaM5p+Q5Liq5ZCN5a2X55qEIGhvb2tcbmV4cG9ydCBmdW5jdGlvbiByZWdpc3Rlckhvb2sgKG5hbWUsIGhvb2spIHtcbiAgcmV0dXJuIGlzLmZ1bmMoaG9vaykgJiYgaG9va1N0b3JlW25hbWVdICYmIGhvb2tTdG9yZVtuYW1lXS5wdXNoKGhvb2spXG59XG5cbmV4cG9ydCBmdW5jdGlvbiBnZXRIb29rcyAobmFtZSkge1xuICByZXR1cm4gaG9va1N0b3JlW25hbWVdIHx8IFtdXG59XG4iXX0=